<template>
  <div class="aw-model">
    <div class="com-sub-top">
      <div class="container-center muli-title">
        AI大模型训推一体机
        <span class="subject-sub-title">DeepSeek / QwQ</span>
      </div>
    </div>
    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">产品介绍</p>
        <div class="pic-text">
            <div class="p-text">
                <p class="desc">
                AI大模型训推一体机通过一站式集成平台，为企业提供高效益、低门槛的AI解决方案，助力企业快速部署AI模型。通过集成的硬件和软件优化降低了技术门槛和成本开支，同时还加强了数据安全性。助力企业快速实现AI技术的商业应用，推动业务创新和效率提升。
                </p>

                <p class="desc" style="margin-top: 32px">
                能够自定义CPU和内存资源等的分配，提供专为大模型和深度学习任务设计的硬件加速器，确保高效执行模型prompt工程、应用开发和微调等关键任务。其优势在于简化AI实施流程、降低成本、增强数据安全，并支持灵活的业务需求适应性，加速企业智能化转型。
                </p>
            </div>
            <img class="pro-img" src="@/assets/model/model_img_1_1@2x.png" alt="">  
        </div>

        <img
          class="ai-model-img"
          src="@/assets/model/model_img_1_2@2x.png"
          alt=""
        />
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">解决方案</p>
        <img  class="sol-img" src="@/assets/model/model_img_4@2x.png" alt="">
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">规格参数</p>
        <img  class="num-img" src="@/assets/model/model_img_5@2x.png" alt="">

        <div class="com-tab-box">
          <div class="p-box container-center">
            <p :class="{ active: key == '1' }" @click="choose('1')">
              AI大模型训推一体机 NV系列
            </p>
            <p :class="{ active: key == '2' }" @click="choose('2')">
              AI大模型训推一体机 XC系列
            </p>
          </div>
        </div>
        <div class="tab-content">
            <div v-if="key == '1'" style="text-align: center;">
                <img class="model-img1" src="@/assets/model/model_img_NV.png" alt="">
            </div>

            <div v-if="key == '2'" style="text-align: center;">
                <img class="model-img1" src="@/assets/model/model_img_XC.png" alt="">
            </div>
            <div class="model-flav-title">
                软件规格
            </div>
            <div class="model-flav-desc">
                包含AIStack嵌入式人工智能管理平台V3.0。通过一站式集成平台，为企业提供高效益、低门槛的 AI 解决方案，助力企业快速部署 AI 模型。平台支持部署开源大模型（支持DeepSeek、百川、千问（Qwen / QwQ）、GLM等开源大模型），通过微调，利用大模型的通用知识，快速提升模型在特定任务上的表现，减少从头开始训练模型所需的时间和资源。平台包含模型管理、资源管理、配置管理、系统管理四大模块：<br/>
                ○ 模型管理包含模型训练、训练模板、模型版本、模型托管、模型预测几个功能模块。用户可使用已有算法或者模型进行模型训练，以及在训练过程中跟踪训练输出，模型训练完成后，可对于模型进行托管，便于对外提供预测服务。<br/>
                ○ 资源管理包括：算法管理、数据集管理、终端设备管理、资源监控。用户可通过资源管理模块，完成对于算法和数据集内容的准备工作，便于后续开展模型训练工作。<br/>
                ○ 配置管理包括：框架管理、镜像管理、规格管理。用户可通过配置管理模块完成对于训练用镜像以及规格的准备工作，便于后续进行模型训练等工作。
                ○ 系统管理包括：项目管理、用户管理、日志管理，用户可通过系统管理模块完成项目和用户的设置。
            </div>
        </div>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">四大优势</p>
        <img  class="advantage-img" src="@/assets/model/model_img_2@2x.png" alt="">
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">私有化架构</p>
        <p class="desc" style="margin-bottom: 16px">AI 大模型训推一体机解决方案全面支持 DeepSeek R1 / QwQ，同时支持部署其他主流大模型的全栈软硬件调优的 AI 平台，可快速开展整个 AI 任务流程。在方案中，针对 DeepSeek / QwQ 模型提供了专门的优化和配置，确保其在私有化部署环境中的高效运行。</p>
        <img  class="pri-img" src="@/assets/model/model_img_3@2x.png" alt="">
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">应用领域</p>
        <p class="desc">AI 大模型训推一体机适用于多种行业和场景，包括金融服务、医疗健康、自动驾驶、智能制造和零售业等。对于 DeepSeek / QwQ 模型，它在自然语言处理领域具有广泛的应用潜力，如智能客服、文本生成、语言翻译等。在金融领域，结合 DeepSeek / QwQ 模型可以用于风险评估和交易系统的文本分析；在医疗领域，助力疾病诊断和个性化治疗的文本信息处理；在自动驾驶中，提升车辆的环境感知能力和决策系统的文本理解能力；在制造业，优化生产流程和质量控制中的文本数据处理；在零售业，改善客户体验和库存管理中的文本分析应用。AI 大模型训推一体机的高效数据处理和模型推理能力，使其成为推动各行各业智能化转型的重要工具，特别是对于需要处理大量文本数据和复杂自然语言处理任务的应用场景。</p>
        <img  class="use-img" src="@/assets/model/model_img_6@2x.png" alt="">
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">应用场景</p>
        <ul class="com-scene-desc com-mt">
          <li>
            <img src="@/assets/model/model_img_7_1@2x.png" alt="" />
            <p class="desc">高校教学和科研应用的知识问答系统</p>
          </li>
          <li>
            <img src="@/assets/model/model_img_7_2@2x.png" alt="" />
            <p class="desc">企业私有化大模型应用开发和微调</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      key: "1",
      subKey: "1"
    };
  },
  methods: {
    choose(val) {
      this.key = val;
    },
    subChoose(val) {
      this.subKey = val;
    },
    go(val) {
        if(val==1) {
            let url = this.key == '1' ? 'https://www.cutech.edu.cn/detail/46-382': 'https://www.cutech.edu.cn/detail/46-362'
            window.open(url, '_blank')
        }else {
            window.open('https://www.cutech.edu.cn/detail/46-421', '_blank')
        }
    }
  },
};
</script>